module.exports = __webpack_public_path__ + "fonts/SuisseIntl-BookItalic.6ef87a5.woff";